import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChoiceRow, EntryLayout } from '../../components/EntryLayout';
import { Button } from '../../components/ui/Button';
import { useLocale } from '../../contexts/LocaleContext';
import { useMetrics } from '../../contexts/MetricsContext';
import type { Locale } from '../../types';

/** MOB/Onboarding/Preferences — one unit preference, language still editable. */
export function OnboardingPreferences() {
  const {
    t,
    locale,
    setLocale
  } = useLocale();
  const {
    unitSystem,
    setUnitSystem
  } = useMetrics();
  const navigate = useNavigate();
  const languages: {
    id: Locale;
    label: string;
  }[] = [{
    id: 'pt-BR',
    label: t('entry.lang.ptBR')
  }, {
    id: 'en-US',
    label: t('entry.lang.enUS')
  }];
  return <EntryLayout title={t('onb.pref.title')} body={t('onb.pref.body')} step={4} totalSteps={5} footer={<Button variant="gold" size="lg" fullWidth onClick={() => navigate('/onboarding/permissoes')} data-id="element-3428" data-mp="3fh41yi2nqwd6">
          {t('onb.continue')}
        </Button>} data-id="element-3427" data-mp="36j0c59kn3dfk">
      <section data-id="element-3429" data-mp="21vvj4lt0dp88">
        <h2 className="bee-overline text-[8.5px] font-bold text-muted" data-id="element-3430" data-mp="21vc3xcuqtexw">
          {t('onb.pref.units')}
        </h2>
        <ul className="mt-2 space-y-2" data-id="element-3431" data-mp="1wxalmu555jnh">
          <li data-id="element-3432" data-mp="1ry7f159ij5de">
            <ChoiceRow label={t('onb.pref.metric')} hint={t('onb.pref.metric.hint')} selected={unitSystem === 'metric'} onClick={() => setUnitSystem('metric')} data-id="element-3433" data-mp="1ryqxqo6zlxsh" />
          </li>
          <li data-id="element-3434" data-mp="2knekypbaqx8o">
            <ChoiceRow label={t('onb.pref.imperial')} hint={t('onb.pref.imperial.hint')} selected={unitSystem === 'imperial'} onClick={() => setUnitSystem('imperial')} data-id="element-3435" data-mp="2koz7psrddbvz" />
          </li>
        </ul>
      </section>

      <section className="mt-4" data-id="element-3436" data-mp="38dige9ebzqol">
        <h2 className="bee-overline text-[8.5px] font-bold text-muted" data-id="element-3437" data-mp="33lqy0m5bwr9j">
          {t('onb.pref.language')}
        </h2>
        <ul className="mt-2 space-y-2" data-id="element-3438" data-mp="11noteuzuq3t2">
          {languages.map(language => <li key={language.id} data-id="element-3439" data-mp="16mrzmirkig2m">
              <ChoiceRow label={language.label} selected={locale === language.id} onClick={() => setLocale(language.id)} data-id="element-3440" data-mp="16lqd9i53q75l" />
            </li>)}
        </ul>
      </section>
    </EntryLayout>;
}